import { SOCIAL_PLATFORMS, countries } from '~/constants';
import { GroupedFilters } from '~/screens/MyAgency/hooks/useGroupFilters';
import { FILTERS } from '~/screens/MyAgency/types';

export const getFilterName = (filter: GroupedFilters) => {
  if (!filter) return;

  if (filter.filterType === 'country') {
    return countries.find((country) => country.code === filter.value)?.name;
  }
  return filter.value;
};

export const isEngagementRate = (platform: string, filterType: string) => {
  if (platform === SOCIAL_PLATFORMS.instagram) {
    return filterType === FILTERS.igReachEngagementRate;
  } else if (platform === SOCIAL_PLATFORMS.tiktok) {
    return filterType === FILTERS.ttAverageEngagementRate;
  } else if (platform === SOCIAL_PLATFORMS.youtube) {
    return filterType === FILTERS.ytAverageEngagementRate;
  }
  return false;
};
